import HistoricAtsTddsDashboardPage from './HistoricAtsTddsDashboardPage';
export { HistoricAtsTddsDashboardPage };
export default HistoricAtsTddsDashboardPage;
